const handler = ( $ ) => {
	// Do stuff
};

( ( $ ) => {
	$( handler );
} )( jQuery );
